import * as React from "react";
import styles from "./index.module.css";

const LoadingIndicator: React.FC = () => {
  return <div className={styles.loadingIndicator} />;
};

export default LoadingIndicator;
